import { Button, useToast } from "@commonlibs";
import { ResetPasswordFormData, ResetPasswordFormProps, ResetPasswordFormFields } from "./ResetPasswordForm.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import { useResetPassword } from "features/auth/hooks/useResetPassword";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfirmPasswordFields from "ui/auth/components/input/ConfirmPasswordFields/ConfirmPasswordFields";
import Form from "ui/common/components/input/Form/Form";
import { AuthRoutes } from "ui/auth/router/AuthRouter.types";

const ResetPasswordForm = ({ token }: ResetPasswordFormProps): JSX.Element => {
    const translate = useTranslate();
    const { showToast } = useToast();
    const navigate = useNavigate();
    const translateError = useTranslate("error");
    const [searchParams, setSearchParams] = useSearchParams();

    function handleError() {
        showToast(translateError("invalidPasswordCode"), { type: "error" });
        searchParams.delete("token");
        setSearchParams(searchParams);
    }

    function handleSuccess() {
        showToast(translate("resetPasswordSucess"), { type: "success" });
        navigate(AuthRoutes.LOGIN);
    }

    const { mutate: resetPassword, isLoading } = useResetPassword({ onSuccess: handleSuccess, onError: handleError });

    const handleSubmit = ({ password }: ResetPasswordFormData) => resetPassword({ password, token });

    return (
        <Form onSubmit={handleSubmit}>
            <ConfirmPasswordFields name={ResetPasswordFormFields.PASSWORD} confirmPassword labelPassword={translate("resetPasswordText")} />
            <Button type="submit" loading={isLoading} variant="primary">
                {translate("updatePassword")}
            </Button>
            <Button variant="text" onClick={() => navigate(AuthRoutes.MAIN)}>
                {translate("goToHome")}
            </Button>
        </Form>
    );
};

export default ResetPasswordForm;
